import React from 'react';
import ReactDOM from 'react-dom/client';
import PublicApp from './PublicApp';
import './public.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PublicApp />
  </React.StrictMode>,
);
